import { useMemo } from 'react'

import { aqsiRegisters } from '@krp/resource-aqsi-ui'

import { useAppSelector } from '../../app/hooks'
import type { RmkSourceSummary } from '../platform/rmkSourceTypes'
import { useMySession } from './useMySession'

/**
 * Сводка плитки источника AQSI (UI-RMK-FLOW 3.4): «Открыто смен: N» — по списку касс кабинета (кэш службы 5 с,
 * только когда плиток немного) и «Ваша работа» — из нашей базы. Ошибка сводки плитку не прячет: строка просто
 * не показывается.
 */
export function useAqsiRmkSummary(resourceId: string, withCabinet: boolean): RmkSourceSummary {
  const args = useMemo(() => ({ resourceId }), [resourceId])
  aqsiRegisters.useQuerySubscription(args, { skip: !withCabinet })
  const selectRegisters = useMemo(() => aqsiRegisters.select(args), [args])
  const registers = useAppSelector(selectRegisters)
  const { session } = useMySession(resourceId)

  return useMemo(() => {
    const lines: string[] = []
    const cabinet = withCabinet && registers.isSuccess ? registers.data : undefined
    if (cabinet !== undefined) {
      const open = cabinet.registers.filter((register) => register.shiftOpen === true).length
      lines.push(`Открыто смен: ${open}`)
    }
    if (session !== undefined) {
      if (session === null) {
        lines.push('Ваша работа: нет')
      } else {
        const register = cabinet?.registers.find((item) => item.deviceId === session.deviceId)
        const where = register?.name ?? (session.deviceSerialNumber !== '' ? `касса ${session.deviceSerialNumber}` : 'касса')
        lines.push(`Ваша работа: ${where}${session.shiftNumber !== null ? `, смена №${session.shiftNumber}` : ''}`)
      }
    }
    return { ownWork: session === undefined ? null : session !== null, lines }
  }, [registers.data, registers.isSuccess, session, withCabinet])
}
